import React from "react";
// nodejs library to set properties for components
import PropTypes from "prop-types";
import cx from "classnames";

// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
import AppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";
import Hidden from "@material-ui/core/Hidden";

// core components
import CartNavbar from "componentsCustom/Navbars/CartNavbar.js";
import MobileNavbar from "componentsCustom/Navbars/MobileNavbar.js";

import styles from "assets/jss/material-dashboard-pro-react/components/adminNavbarStyle.js";

const useStyles = makeStyles(styles);

export default function Navbar(props) {
  const classes = useStyles();
  const {
    color,
    rtlActive,
    cart,
    currency,
    museum,
    customStyle,
    shippingInfo,
    cartParams,
    toggleCartSideBar = () => {}
  } = props;
  const appBarClasses = cx({
    [" " + classes[color]]: color
  });

  return (
    <AppBar className={classes.appBar + appBarClasses} style={{position: "fixed"}}>
      <Toolbar className={classes.container}>
        {/*<Hidden smDown implementation="css">
          <div className={classes.idebarMinimize}>
            {props.miniActive ? (
              <Button
                justIcon
                round
                color="white"
                onClick={props.sidebarMinimize}
                onMouseEnter={() => {
                  setIndexHover(1);
                }} // Or onMouseOver
                onMouseLeave={() => {
                  setIndexHover(0);
                }}
                style={{
                  backgroundColor: indexHover
                    ? customStyle.buttonAction
                    : undefined
                }}
              >
                <ViewList className={classes.sidebarMiniIcon} />
              </Button>
            ) : (
              <Button
                justIcon
                round
                color="white"
                onClick={props.sidebarMinimize}
                onMouseEnter={() => {
                  setIndexHover(1);
                }} // Or onMouseOver
                onMouseLeave={() => {
                  setIndexHover(0);
                }}
                style={{
                  backgroundColor: indexHover
                    ? customStyle.buttonAction
                    : undefined
                }}
              >
                <MoreVert className={classes.sidebarMiniIcon} />
              </Button>
            )}
          </div>
        </Hidden>*/}
        <div className={classes.flex}>
          {/* Here we create navbar brand, based on route name */}
          {/* <Button href="#" className={classes.title} color="transparent">
            {t(brandText)}
          </Button> */}
        </div>
        <Hidden mdUp implementation="css">
          <MobileNavbar
            cart={cart}
            rtlActive={rtlActive}
            customStyle={customStyle}
          />
        </Hidden>
        <Hidden smDown implementation="css">
          <CartNavbar
            cart={cart}
            rtlActive={rtlActive}
            museum={museum}
            currency={currency}
            customStyle={customStyle}
            shippingInfo={shippingInfo}
            cartParams={cartParams}
            onCartPress={toggleCartSideBar}
          />
        </Hidden>
        {/* <Hidden mdUp implementation="css">
          <Button
            className={classes.appResponsive}
            color="transparent"
            justIcon
            aria-label="open drawer"
            onClick={props.handleDrawerToggle}
          >
            <Menu />
          </Button>
        </Hidden> */}
      </Toolbar>
    </AppBar>
  );
}

Navbar.propTypes = {
  cart: PropTypes.arrayOf(PropTypes.object).isRequired,
  currency: PropTypes.shape({
    name: PropTypes.string,
    rate: PropTypes.number,
    symbol: PropTypes.string
  }).isRequired,
  cartParams: PropTypes.shape({
    totalPrice: PropTypes.number,
    deliveryCost: PropTypes.number,
    servicesFees: PropTypes.number,
    total: PropTypes.number,
    cartCounter: PropTypes.number
  }).isRequired,
  museum: PropTypes.object.isRequired,
  shippingInfo: PropTypes.shape({
    type: PropTypes.string
  }).isRequired,
  color: PropTypes.oneOf(["primary", "info", "success", "warning", "danger"]),
  rtlActive: PropTypes.bool,
  brandText: PropTypes.string,
  miniActive: PropTypes.bool,
  handleDrawerToggle: PropTypes.func,
  sidebarMinimize: PropTypes.func,
  customStyle: PropTypes.object
};

Navbar.defaultProps = {
  rtlActive: false,
  brandText: "",
  miniActive: false,
  handleDrawerToggle: () => {},
  sidebarMinimize: () => {},
  customStyle: {}
};
